export default {
  setFaqList ({ commit }, payload) {
    commit('setFaqList', payload)
  }
}
